// src/components/dashboard/EditTrackedProductsModal.js
import React, { useState, useEffect } from 'react';
import styles from './EditTrackedProductsModal.module.css';

const EditTrackedProductsModal = ({ isOpen, onClose, allProducts, currentTrackedIds, onSave }) => {
    // Use a Set for efficient add/remove/check operations
    const [selectedIds, setSelectedIds] = useState(new Set(currentTrackedIds));

    useEffect(() => {
        // Reset local state if the modal is reopened with different initial props
        setSelectedIds(new Set(currentTrackedIds));
    }, [currentTrackedIds, isOpen]);

    const handleToggle = (productId) => {
        setSelectedIds(prev => {
            const newSet = new Set(prev);
            if (newSet.has(productId)) {
                newSet.delete(productId);
            } else {
                // Enforce a limit of 5 selections
                if (newSet.size < 5) {
                    newSet.add(productId);
                } else {
                    alert("You can only track up to 5 products at a time.");
                }
            }
            return newSet;
        });
    };

    const handleSave = () => {
        // Convert the Set back to an array for saving
        onSave(Array.from(selectedIds));
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2>Select Products to Monitor</h2>
                    <button onClick={onClose} className={styles.closeButton}>×</button>
                </div>
                <div className={styles.instructions}>
                    You can select up to 5 products. ({selectedIds.size} / 5 selected)
                </div>
                <div className={styles.productList}>
                    {allProducts.map(product => (
                        <div key={product._id} className={styles.productItem}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={selectedIds.has(product._id)}
                                    onChange={() => handleToggle(product._id)}
                                    // Disable checking more if limit is reached
                                    disabled={selectedIds.size >= 5 && !selectedIds.has(product._id)}
                                />
                                {product.productName} (Qty: {product.quantity})
                            </label>
                        </div>
                    ))}
                </div>
                <div className={styles.footer}>
                    <button onClick={onClose} className={styles.cancelButton}>Cancel</button>
                    <button onClick={handleSave} className={styles.saveButton}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default EditTrackedProductsModal;